import React, { useState, useContext, useEffect } from 'react';
import { Modal, Button, Form, InputGroup } from 'react-bootstrap';
import { IdentityContext } from '../../../../../../../../context/identity-context';
import ReportsService from '../../../../../../../../services/reports-service';

const RequestForReportModal = ({ show, handleClose }) => {
  const [bpIds, setBpIds] = useState(['']);
  const [dataAsOf, setDataAsOf] = useState('');
  const [purpose, setPurpose] = useState('General');
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [successCount, setSuccessCount] = useState(0);
  const [validated, setValidated] = useState(false);
  const { user } = useContext(IdentityContext);

  const reportsService = new ReportsService();

  useEffect(() => {
    if (show) {
      setBpIds(['']);
      setDataAsOf('');
      setPurpose('General');
      setValidated(false);
    }
  }, [show]);

  const handlebpIdChange = (index, value) => {
    const newbpIds = [...bpIds];
    newbpIds[index] = value;
    setBpIds(newbpIds);
  };

  const addbpIdField = () => {
    setBpIds([...bpIds, '']);
  };

  const removebpIdField = (index) => {
    if (bpIds.length > 1) {
      const newbpIds = bpIds.filter((_, i) => i !== index);
      setBpIds(newbpIds);
    }
  };

  const today = new Date().toISOString().split('T')[0];

  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      e.stopPropagation();
      setValidated(true);
      return;
    }

    // Extra precaution: ensure each bpId is exactly 11 characters long
    for (const bpId of bpIds) {
      if (bpId.length !== 11) {
        alert("Each bpId must be exactly 11 characters.");
        return;
      }
    }

    const reportPromises = bpIds.map((bpId) =>
      reportsService.requestCertificationOfHoldings(
        bpId,
        dataAsOf,
        purpose,
        user.attributes['email'],
        user.attributes['custom:entity_id']
      )
    );

    const results = await Promise.allSettled(reportPromises);
    const successfulRequests = results.filter(result => result.status === 'fulfilled').length;
    setSuccessCount(successfulRequests);

    handleClose();
    setShowSuccessModal(true);

    // Refresh the page after 3 seconds (optional)
    setTimeout(() => {
      window.location.reload();
    }, 3000);
  };

  const handleSuccessModalClose = () => {
    setShowSuccessModal(false);
    window.location.reload();
  };

  return (
    <>
      <Modal show={show} onHide={handleClose}>
        <Form noValidate validated={validated} onSubmit={handleSubmit}>
          <Modal.Header closeButton>
            <Modal.Title>Request for Report</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {bpIds.map((bpId, index) => (
              <Form.Group key={index} controlId={`bpId-${index}`} className="mb-3">
                <Form.Label>Enter bpId</Form.Label>
                <InputGroup>
                  <Form.Control
                    type="text"
                    required
                    minLength={11}
                    maxLength={11}
                    value={bpId}
                    onChange={(e) => handlebpIdChange(index, e.target.value)}
                    placeholder="Enter bpId"
                    title="bpId must be exactly 11 characters"
                  />
                  {index === bpIds.length - 1 ? (
                    <Button variant="outline-secondary" onClick={addbpIdField}>
                      +
                    </Button>
                  ) : (
                    <Button variant="outline-danger" onClick={() => removebpIdField(index)}>
                      -
                    </Button>
                  )}
                </InputGroup>
                <Form.Control.Feedback type="invalid">
                  Please enter a bpId exactly 11 characters long.
                </Form.Control.Feedback>
              </Form.Group>
            ))}
            <Form.Group controlId="dataAsOf" className="mb-3">
              <Form.Label>Data as of</Form.Label>
              <Form.Control
                type="date"
                required
                max={today}
                value={dataAsOf}
                onChange={(e) => setDataAsOf(e.target.value)}
              />
              <Form.Control.Feedback type="invalid">
                Please provide a valid date.
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group controlId="purpose" className="mb-3">
              <Form.Label>Purpose</Form.Label>
              <Form.Control
                as="select"
                required
                value={purpose}
                onChange={(e) => setPurpose(e.target.value)}
              >
                <option value="">Select purpose</option>
                <option value="General">General</option>
              </Form.Control>
              <Form.Control.Feedback type="invalid">
                Please select a purpose.
              </Form.Control.Feedback>
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              Cancel
            </Button>
            <Button variant="primary" type="submit">
              Submit Request
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>

      {/* Success Modal */}
      <Modal show={showSuccessModal} onHide={handleSuccessModalClose}>
        <Modal.Header closeButton>
          <Modal.Title>Request Submitted</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {successCount > 0
            ? <p>{successCount} report{successCount > 1 ? 's' : ''} successfully requested.</p>
            : <p>There was an error. No reports were requested.</p>
          }
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={handleSuccessModalClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default RequestForReportModal;
